import { useState, useCallback } from 'react';
import moment from 'moment';

export const useReadingData = () => {
  const [readingState, setReadingState] = useState({
    type: 'COU_C',
    date: moment(),
    mDMBPEstate: {
      mDMEstate: {
        mDMMeterPointList: [],
      },
    },
    mDMMeterPoint: {
      mDMMeterRegisterList: [],
    },
    meter: {},
  });

  const updateReadingState = useCallback((updates) => {
    setReadingState((prevState) => ({ ...prevState, ...updates }));
  }, []);

  const resetReadingState = useCallback(() => {
    setReadingState({
      type: 'COU_C',
      date: moment(),
      mDMBPEstate: {
        mDMEstate: {
          mDMMeterPointList: [],
        },
      },
      mDMMeterPoint: {
        mDMMeterRegisterList: [],
      },
      meter: {},
    });
  }, []);

  return {
    readingState,
    updateReadingState,
    resetReadingState,
  };
};
